<div class="task-home-container">
  <div class="home-content">
    <img class="duty-img" src="{{ (state$ | async).image }}" alt="duty" [ngClass]="{ 'if-banner-active': hasBanner$ | async }" />
    @if (!(hasParkedTasks$ | async) && (state$ | async).message && !(state$ | async).hasOpenNarRequest) {
      <span class="home-message">{{ (state$ | async).message | translate }}</span>
    }
  </div>
</div>
